<template>
  <div class="myorders">
    <mainmenu selected="my-orders"></mainmenu>
    <div class="container-fluid">
      <h1>{{$t('myorders.page_title')}}</h1>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Filters</span>
        </div>
        <div>
          <el-form :inline="true" :model="Filters">
            <el-form-item :label="$t('myorders.filter_status')">
              <el-select v-model="Filters.order_status">
                <el-option v-for="(s,idx) in Statuses" :key="'status-' + idx" :label='s.name' :value='s.id'></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="refresh_info">{{$t('filter')}}</el-button>
            </el-form-item>
            
          </el-form>
        </div>
      </el-card>


       <el-table :data="Results" style="width: 100%; margin-top: 50px" v-loading="tableLoadingVisible">

          <el-table-column prop="Id" :label="$t('myorders.unique_id')" width="60"></el-table-column>
          <el-table-column :label="$t('myorders.request_date')" width="250">
            <template slot-scope="scope">
                <strong>{{scope.row.RequestDate}}</strong>
                <div v-if="scope.row.Buyer_NotifyForInvoiceOnApprove =='1'">
                  <el-tag  size="mini">{{$t('factories.notify_for_invoice_approval')}}</el-tag>
                </div>
            </template>
          </el-table-column>

          <el-table-column prop="FactoryCode" :label="$t('myorders.factory_code')" width="150"></el-table-column>
          <el-table-column prop="SellerName" :label="$t('myorders.seller_name')" width="200"></el-table-column>

          <el-table-column prop="BuyerFactoryCode" :label="$t('myorders.buyer_factory_code')" width="150"></el-table-column>
          <el-table-column prop="BuyerName"        :label="$t('myorders.buyer_name')"  width="200"></el-table-column>
          
          <el-table-column :label="$t('myorders.article_info')" width="250">
            <template slot-scope="scope">
                <strong>{{scope.row.ArticleNumber}}</strong> ({{$t(scope.row.ProductStatus)}}) <br/>
                <em>{{scope.row.ProductCategory}}</em> <br/>
                <p class="small">{{scope.row.ProductDescription}}</p>
            </template>
          </el-table-column>

          <el-table-column :label="$t('myorders.product_status')" width="400">
            <template slot-scope="scope">
                <el-alert v-if="scope.row.RequestStatus=='accepted'" :title="$t(scope.row.RequestStatus)" type="success" :closable="false"></el-alert>
                <el-alert v-if="scope.row.RequestStatus=='pending'" :title="$t(scope.row.RequestStatus)" type="warning" :closable="false"></el-alert>
                <el-alert v-if="scope.row.RequestStatus=='rejected'" :title="$t(scope.row.RequestStatus)" type="error" :closable="false"></el-alert>
                <el-alert v-if="scope.row.RequestStatus=='rejected'" :title="$t('myorders.reason') + ': ' + scope.row.RejectReason" type="error" :closable="false"></el-alert>
            </template>
          </el-table-column>

          <el-table-column prop="Quantity" :label="$t('myorders.quantity')" width="100"></el-table-column>
          <el-table-column :label="$t('myorders.price')" width="180">
            <template slot-scope="scope">
                {{scope.row.Price|format_money}} &euro;
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="$t('myorders.operations')" width="200">
            <template slot-scope="scope">
              
              <div v-if="$rights.is_not_guest()">
                <div v-if="scope.row.RequestStatus=='pending' && scope.row.ImTheSeller==1">
                    <el-button type="danger"  size="mini"  plain @click="reject(scope.row)" >{{$t('myorders.reject')}} </el-button>
                    <el-button type="success" size="mini"  plain @click="approve(scope.row)">{{$t('myorders.approve')}}</el-button>
                </div>
              </div>
              
              <div v-if="scope.row.RequestStatus=='accepted'">
                <a :href="scope.row.PdfDownloadUrl" target="_blank" class="button-link el-button el-button--success is-plain el-button--mini">
                  <i class="el-icon-download"></i>
                  {{$t('myorders.download_delivery_note')}}
                </a>
              </div>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
          @size-change        = "refresh_info"
          @current-change     = "refresh_info"
          :page-size.sync     = "PaginationInfo.PerPage"
          :current-page.sync  = "PaginationInfo.Page"
          :total              = "PaginationInfo.RowCount"
          layout              = "pager">
      </el-pagination>


    </div>
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";

export default {
  name: "my-orders",
  components: {
    "mainmenu": MainMenu
  },
  data () {
    return { 
      tableLoadingVisible: false,
      Results: [],
      Filters: { order_status: "all" },
      Statuses: [ {id:'all', name: this.$t('all') }, {id:'pending', name: this.$t('pending') }, {id:'accepted', name: this.$t('accepted') }, {id:'rejected', name: this.$t('rejected') } ],
      PaginationInfo: { Page: 1, PerPage: 10, RowCount: 0, PageSizes: [10, 25, 50, 100] },
      Categories: [],
    }
  },
  methods: {
    refresh_info: function() {
      this.loadingVisible = true;
      this.$http
          .post('myorders/refresh_info',  { Filters: this.Filters, PaginationInfo: this.PaginationInfo } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Results = response.body.Results;
              this.PaginationInfo = response.body.PaginationInfo;
            } else {
              this.$router.push("/");
            }
          }); 
    },
    approve: async function(item)
    {
        var confirmed = await this.$confirm( this.$t('myorders.are_you_sure_you_approve'), this.$t("warning_title"), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
        });

        if( confirmed )
        {
          var confirmed2 = true;
          if( item.Buyer_NotifyForInvoiceOnApprove == '1' )
          {
            confirmed2 = await this.$confirm( this.$t('myorders.attention_you_need_to_attach_invoice_to_delivery'), this.$t("warning_title"), {
              confirmButtonText: this.$t('confirm'),
              cancelButtonText: this.$t('cancel'),
              type: 'warning'
            });
          }
          if( confirmed2 ) 
          {
            this.loadingVisible      = true;
            var response             = await this.$http.post('myorders/aprove',  { order_id: item.Id } );
            this.tableLoadingVisible = false;

            if( settings.verify_response(response, this.$rights)) {
                this.refresh_info();
            } else {
                this.$router.push("/");
            }
          }
        }
    },
    validate_reason: function(reason){
        return  reason != null && reason.length > 3;
    },
    reject: function(item){
        this.$prompt(this.$t('myorders.rejection_reason'), this.$t("warning_title"), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          inputValidator: this.validate_reason,
          inputErrorMessage: this.$t('myorders.wrong_validate_reason')

        }).then(value => {
            this.loadingVisible = true;
            this.$http
                .post('myorders/reject',  { order_id: item.Id, reason: value} )
                .then(function (response) {
                    this.tableLoadingVisible = false;
                    if( settings.verify_response(response, this.$rights)) {
                        this.refresh_info();
                    } else {
                        this.$router.push("/");
                    }
                }); 
        }).catch(() => { });
    },
    logout: function() {
      settings.logout();
      this.$router.push("/");
    }
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>
  .button-link{
    text-decoration: none;
  }
  .el-button--mini{
    font-size:9px;
  }
</style>